import { useRef, useState } from "react";
import { asset } from "../../utils/format";

export default function ItemGallery({ item }) {
  const images = [...new Set((item.images?.length ? item.images : [item.image]).filter(Boolean))];
  const [index, setIndex] = useState(0);
  const start = useRef(null);
  const go = (delta) => setIndex((current) => (current + delta + images.length) % images.length);
  return (
      <div className="gallery">
        <div className="heroimg" tabIndex={images.length > 1 ? 0 : undefined} style={{ touchAction: "pan-y" }}
          onPointerDown={(e) => {
            if (e.target.closest("button")) return;
            start.current = { x: e.clientX, y: e.clientY };
            e.currentTarget.setPointerCapture?.(e.pointerId);
          }}
          onPointerUp={(e) => {
            if (!start.current) return;
            const dx = e.clientX - start.current.x;
            const dy = e.clientY - start.current.y;
            start.current = null;
            if (Math.abs(dx) >= 38 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
          }}
          onPointerCancel={() => { start.current = null; }}
          onKeyDown={(e) => {
            if (e.key === "ArrowLeft") go(-1);
            if (e.key === "ArrowRight") go(1);
          }}>
          <div className="productPhotoFrame"><img id="productHero" src={asset(images[index])} alt={`${item.name} — ${index + 1} of ${images.length}`} draggable={false} /></div>
          {images.length > 1 && <>
            <button type="button" className="galleryArrow galleryArrowPrev" aria-label="Previous photo" onClick={() => go(-1)}><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 6-6 6 6 6" /></svg></button>
            <button type="button" className="galleryArrow galleryArrowNext" aria-label="Next photo" onClick={() => go(1)}><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 6 6 6-6 6" /></svg></button>
            <div className="galleryDashIndicators" aria-label={`Photo ${index + 1} of ${images.length}`}>
              {images.map((_, i) => <button key={i} type="button" aria-label={`Show photo ${i + 1}`} aria-pressed={i === index}
                className={i === index ? "active" : ""} onClick={() => setIndex(i)} />)}
            </div>
          </>}
        </div>
      </div>
  );
}
